import { useQuery } from "@tanstack/react-query";
import { getVisualAnalysis } from "@/api/visualAnalysis";

export const useGetVisualAnalysis = () => {
  return useQuery({
    queryKey: ["visual-analysis"],
    queryFn: getVisualAnalysis,
    staleTime: 10 * 60 * 1000,
  });
};
